import type { TestimonialFormData } from '../types/landing.types';

export const STATUS_OPTIONS = [
	{ value: 'yes', label: 'Sim' },
	{ value: 'no', label: 'Não' },
];

export const DEFAULT_TESTIMONIAL_FORM: TestimonialFormData = {
	name: '',
	occupation: '',
	testimonial: '',
	status: '',
};

export const LANDING_ROUTES = {
	CONTROL: '/configuracoes/landing',
	NEW_TESTIMONIAL: '/configuracoes/landing/depoimentos/novo',
	VIEW_PLAN: (planId: string, landingPlanId: string) =>
		`/configuracoes/landing/planos/ver?planId=${planId}&landingPlanId=${landingPlanId}`,
	VIEW_TESTIMONIAL: (id: string) => `/configuracoes/landing/depoimentos/ver?id=${id}`,
} as const;
